"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserProvider = void 0;
const React = __importStar(require("react"));
const user_context_1 = require("./user-context");
const user_hook_1 = require("./user-hook");
function UserProvider({ children, meUrl, logoutUrl, checkPermission, mockUser, }) {
    const { context } = (0, user_hook_1.useUser)(meUrl, logoutUrl, checkPermission, mockUser);
    const [loaded, setLoaded] = React.useState(false);
    React.useEffect(() => {
        context.reload().then(() => {
            setLoaded(true);
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return (React.createElement(user_context_1.UserContext.Provider, { value: context }, loaded && children));
}
exports.UserProvider = UserProvider;
//# sourceMappingURL=user-provider.js.map